import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import { Input } from '@geely/ui';

interface MaskedPlateInputProps {
  value: string;
  onChange: (value: string) => void;
  name: string;
}

export function MaskedPlateInput({ value, onChange, name }: MaskedPlateInputProps) {
  const { ref, setValue } = useIMask<HTMLInputElement>(
    {
      mask: 'aaa0x00',
      definitions: {
        a: /[A-Z]/,
        x: /[A-Z0-9]/,
        '0': /[0-9]/,
      },
      prepare: (str: string) => str.toUpperCase(),
    },
    { onAccept: (maskedValue: string) => onChange(maskedValue) }
  );

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value, setValue]);

  return <Input ref={ref} name={name} placeholder="ABC1D23" />;
}
